import { render, staticRenderFns } from "./EditWaffle.vue?vue&type=template&id=636f49de&scoped=true&"
import script from "./EditWaffle.vue?vue&type=script&lang=js&"
export * from "./EditWaffle.vue?vue&type=script&lang=js&"
import style0 from "./EditWaffle.vue?vue&type=style&index=0&id=636f49de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636f49de",
  null
  
)

export default component.exports